import { module as BaseModule } from 'modujs'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { body } from '../utils/environment'

gsap.registerPlugin(ScrollTrigger)

export default class extends BaseModule {
  constructor(m) {
    super(m)

    this.toLight = this.$('to-light')[0]
    this.toDark = this.$('to-dark')[0]
  }

  init() {
    if (this.toLight) this.toLightTheme()
    if (this.toDark) this.toDarkTheme()
  }

  toLightTheme() {
    ScrollTrigger.create({
      trigger: this.toLight,
      start: 'top 70%',
      onEnter: () => body.classList.add('has-light-theme'),
      onLeaveBack: () => body.classList.remove('has-light-theme'),
    })
  }

  toDarkTheme() {
    ScrollTrigger.create({
      trigger: this.toDark,
      start: 'top 40%',
      onEnter: () => body.classList.add('has-dark-theme'),
      onLeaveBack: () => body.classList.remove('has-dark-theme'),
    })
  }
}
